import { render, staticRenderFns } from "./phoneCheck.vue?vue&type=template&id=61ed440c&scoped=true&"
import script from "./phoneCheck.vue?vue&type=script&lang=js&"
export * from "./phoneCheck.vue?vue&type=script&lang=js&"
import style0 from "./phoneCheck.vue?vue&type=style&index=0&id=61ed440c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed440c",
  null
  
)

export default component.exports